import { useCategorias } from '../../hooks/useCategorias';
import { useProveedores } from '../../hooks/useProveedores';

/**
 * Controles de filtro compartidos por los reportes (PROMPT_N°054).
 *
 * Categoría y proveedor salen de los mismos endpoints que el resto de la
 * aplicación; no se duplican listas.
 */

export const CLASE_INPUT =
  'w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500';

export const CLASE_LABEL =
  'block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1';

export function Campo({
  etiqueta,
  children,
}: {
  etiqueta: string;
  children: React.ReactNode;
}) {
  return (
    <div>
      <label className={CLASE_LABEL}>{etiqueta}</label>
      {children}
    </div>
  );
}

export function SelectCategoria({
  valor,
  onChange,
}: {
  valor: string;
  onChange: (v: string) => void;
}) {
  const { data } = useCategorias();
  const categorias: { id: number; nombre: string }[] = Array.isArray(data)
    ? data
    : ((data as any)?.data ?? []);

  return (
    <Campo etiqueta="Categoría">
      <select
        className={CLASE_INPUT}
        value={valor}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Todas</option>
        {categorias.map((c) => (
          <option key={c.id} value={c.id}>
            {c.nombre}
          </option>
        ))}
      </select>
    </Campo>
  );
}

export function SelectProveedor({
  valor,
  onChange,
  etiqueta = 'Proveedor',
}: {
  valor: string;
  onChange: (v: string) => void;
  etiqueta?: string;
}) {
  // `activo: true` a propósito: `GET /proveedores` devuelve también los
  // inactivos y un filtro de reporte no debería ofrecer proveedores dados
  // de baja.
  const { data } = useProveedores({ activo: true, limit: 500 });
  const proveedores: { id: number; nombre: string }[] =
    (data as any)?.data ?? (Array.isArray(data) ? data : []);

  return (
    <Campo etiqueta={etiqueta}>
      <select
        className={CLASE_INPUT}
        value={valor}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Todos</option>
        {proveedores.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nombre}
          </option>
        ))}
      </select>
    </Campo>
  );
}

export function Casilla({
  etiqueta,
  marcada,
  onChange,
  ayuda,
}: {
  etiqueta: string;
  marcada: boolean;
  onChange: (v: boolean) => void;
  ayuda?: string;
}) {
  return (
    <label className="flex items-start gap-2 cursor-pointer select-none">
      <input
        type="checkbox"
        checked={marcada}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
      />
      <span>
        <span className="text-sm text-gray-800 dark:text-gray-200">
          {etiqueta}
        </span>
        {ayuda && (
          <span className="block text-xs text-gray-500 dark:text-gray-400">
            {ayuda}
          </span>
        )}
      </span>
    </label>
  );
}
